module.exports = __webpack_public_path__ + "img/upload_active.0cc757b9.svg";